export default __webpack_public_path__ + "static/media/huawei-color.f674b075.svg";